export const LOCALES = {
  ENGLISH: "en-CA",
  FRENCH: "fr-CA"
};
